import api from '../../utils/api';
import { setAlert } from './alert';
import {
  REGISTER_SUCCESS,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
  UPDATE_USER_DETAILS,
  UPDATE_CUSTOM_LINKS,
  GET_EMAIL_NOTIFICATION,
} from '../types';
import setAuthToken from '../../utils/setAuthToken';
import { socketIo } from '../..';

// Load User
export const loadUser = () => async (dispatch) => {
  try {
    const res = await api.get('/auth');
    dispatch({
      type: USER_LOADED,
      payload: res.data
    });
    dispatch({
      type: GET_EMAIL_NOTIFICATION,
      payload: res.data.bookForm
    });
    socketIo.emit('SET_SOCKET_ID', { user_id: res.data?.user?.id || "" });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR
    });
  }
}

// Register User
export const signup = (data) => async (dispatch) => {
  try {
    const res = await api.post('/users', data);
    const { isSuper } = res.data;
    if (isSuper) {
      setAuthToken(res.data.token);
      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data
      });
      await dispatch(loadUser());
    }
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

// Login User
export const login = (data) => async (dispatch) => {
  try {
    const res = await api.post('/auth', data);
    const { isSuper, verified } = res.data;
    if (isSuper || verified) {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data
      });
      await dispatch(loadUser());
    }
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
};

// Send Verification Email
export const sendVerificationEmail = (data) => async (dispatch) => {
  try {
    const res = await api.post('/auth/send-verification-email', data);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
};

// Logout
export const logout = () => (dispatch) => {
  setAuthToken();
  dispatch({
    type: LOGOUT
  });
};

export const readNotification = () => async (dispatch) => {
  try {
    const res = await api.get('/auth/read-notification');
    await dispatch(loadUser());
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const updateUserDetails = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/users/update-details`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    const updatedUser = {
			firstName: res.data.firstName,
			lastName: res.data.lastName,
			username: res.data.username,
			email: res.data.email,
			country: res.data.country,
			city: res.data.city,
			website: res.data.website,
    }
    dispatch({
      type: UPDATE_USER_DETAILS,
      payload: updatedUser
    });
    dispatch({ type: UPDATE_CUSTOM_LINKS, payload: res.data.customLinks })
    return res.status === 200;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const updateUserAvatar = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/users/update-avatar`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    dispatch({
      type: UPDATE_USER_DETAILS,
      payload: res.data
    })
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const forgotPassword = (data) => async (dispatch) => {
  try {
    const res = await api.post('/auth/forgot-password', data);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
};

export const resetPassword = (data) => async (dispatch) => {
  try {
    const res = await api.post('/auth/reset-password', data);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
};

export const verifyUser = (data) => async (dispatch) => {
  try {
    const res = await api.get('/users/verify/' + data);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
};

export const checkUsername = (data) => async (dispatch) => {
  try {
    const res = await api.get('/users/check-username/' + data);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
};
